import { createAction, props } from "@ngrx/store";

export const loadDevices = createAction("[Device] Load Devices");
export const loadDevicesSuccess = createAction(
  "[Device] Load Devices Success",
  props<{ devices: MediaDeviceInfo[] }>()
);
export const loadDevicesFailure = createAction(
  "[Device] Load Devices Failure",
  props<{ error: Error }>()
);
